module.exports = __webpack_public_path__ + "img/file-upload.c505455c.svg";